import React, { useCallback, useState } from "react";
import { Button, Card, Collapse, GridLegacy, IconButton, MenuItem, Paper, Stack, Typography } from "@mui/material";
import CardBody from "../../../../components/Card/CardBody";
import MenuSyncSettings from "../MenuSyncSettings";
import { useFormContext, useWatch } from "react-hook-form";
import { yellow } from "@mui/material/colors";
import FormSelectTC from "../../../../components/Forms/FormSelectTC";
import { Link, Refresh } from "@mui/icons-material";
import axios from "axios";
import TranslationWrapper from "../../../../components/TranslationWrapper/TranslationWrapper";

export default function Deliverect() {
  const vestigingId = useWatch({ name: "id" });
  const externalLocationId = useWatch({ name: "apiaccounts__deliverect_api_details.external_location_id" });
  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
          <ExternalLocationIdView vestigingId={vestigingId} />
        </CardBody>
        <Collapse in={externalLocationId != null} unmountOnExit>
          <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
            <GridLegacy container spacing={1} style={{ maxWidth: 1400 }}>
              <Paper sx={{ p: 1, backgroundColor: yellow[100] }}>
                <Typography>
                  Webhooks which need to be set up in Deliverect Backoffice: <br />
                  https://jamezz.app/pos-api/deliverect/deliverect-api/register <br />
                  https://jamezz.app/pos-api/deliverect/deliverect-api/menu-update <br />
                  https://jamezz.app/pos-api/deliverect/deliverect-api/order-status-update
                </Typography>
              </Paper>

              <FormSelectTC
                defaultValue={"production"}
                name={"apiaccounts__deliverect_api_details.environment"}
                options={[
                  <MenuItem value={"production"}>Production</MenuItem>,
                  <MenuItem value={"staging"}>Staging</MenuItem>,
                ]}
                tDefault={"Environment"}
                tKey={"vestigingen.form.apiaccounts__deliverect_api_details.label.environment"}
              />

              {/*<FormTextTC*/}
              {/*  name={"apiaccounts__deliverect_api_details.accountId"}*/}
              {/*  tKey={"vestigingen.form.apiaccounts__deliverect_api_details.label.accountId"}*/}
              {/*  tDefault={"accountId"}*/}
              {/*/>*/}
              {/*<FormTextTC*/}
              {/*  name={"apiaccounts__deliverect_api_details.channel_link_id"}*/}
              {/*  tKey={"vestigingen.form.apiaccounts__deliverect_api_details.label.channel_link_id"}*/}
              {/*  tDefault={"Deliverect Channel Id"}*/}
              {/*/>*/}
              <StatusView />
              {/*<FormTextTC*/}
              {/*  name={"apiaccounts__taurusMachineID"}*/}
              {/*  tKey={"vestigingen.form.taurus.label.machineID"}*/}
              {/*  tDefault={"Taurus Machine ID (e.g. 123)"}*/}
              {/*/>*/}
              {/*<FormAsyncTC*/}
              {/*  name={"apiaccounts__taurusTerminalID"}*/}
              {/*  tKey={"vestigingen.form.taurus.label.terminalID"}*/}
              {/*  tDefault={"Taurus Terminal ID"}*/}
              {/*  async={{ url: `core/pos-api/taurus/getTerminals?vid=${vestigingId}`, searchField: "naam" }}*/}
              {/*/>*/}
              {/*<FormAsyncTC*/}
              {/*  name={"apiaccounts__taurusMenus"}*/}
              {/*  tKey={"apiaccounts__taurusMenus"}*/}
              {/*  tDefault={"Sync following menus"}*/}
              {/*  async={{ url: `core/pos-api/taurus/getMenus?vid=${vestigingId}`, searchField: "naam" }}*/}
              {/*  multiple={true}*/}
              {/*/>*/}
            </GridLegacy>

            <MenuSyncSettings v2Only={undefined} />
          </CardBody>
        </Collapse>
      </Card>
    </div>
  );
}

function StatusView() {
  const deliverectChannelId = useWatch({ name: "apiaccounts__deliverect_api_details.channel_link_id" });
  const [requestStatus, setRequestStatus] = useState<"init" | "loading" | "done">("init");
  const [result, setResult] = useState<"register" | "active" | "inactive" | null>();

  const refresh = useCallback(() => {
    if (requestStatus != "loading") {
      setRequestStatus("loading");
      axios
        .get("core/pos-api/deliverect/status?deliverect_channel_id=" + deliverectChannelId)
        .then((response) => {
          setResult(response.data?.data);
        })
        .finally(() => {
          setRequestStatus("done");
        });
    }
  }, [requestStatus, deliverectChannelId]);

  return (
    <Stack alignItems={"center"} direction={"row"} gap={1}>
      <Typography>Connection Status: </Typography>
      <Typography>
        {requestStatus === "loading" ? (
          "Loading"
        ) : (
          <>
            {result === undefined ? "Click to get status" : null}
            {result === null ? "Channel not registered" : null}
            {result === "register" ? "Channel is registered, but not yet active" : null}
            {result === "active" ? "Channel is active" : null}
            {result === "inactive" ? "Channel is disabled" : null}
          </>
        )}
      </Typography>
      <IconButton disabled={requestStatus === "loading"} onClick={refresh}>
        <Refresh />
      </IconButton>
    </Stack>
  );
}

function ExternalLocationIdView({ vestigingId }: { vestigingId: number }) {
  const externalLocationId = useWatch({ name: "apiaccounts__deliverect_api_details.external_location_id" });
  const { setValue } = useFormContext();
  const [requestStatus, setRequestStatus] = useState<"init" | "loading" | "done">("init");
  // const [result, setResult] = useState();

  const createExternalLocationId = useCallback(() => {
    if (requestStatus != "loading") {
      setRequestStatus("loading");
      axios
        .get("core/pos-api/deliverect/createExternalLocationId?vid=" + vestigingId)
        .then((response) => {
          setValue("apiaccounts__deliverect_api_details.external_location_id", response.data?.data);
        })
        .finally(() => {
          setRequestStatus("done");
        });
    }
  }, [requestStatus, vestigingId]);
  if (externalLocationId == null) {
    return (
      <Stack alignItems={"center"} direction={"row"} gap={1}>
        <Typography>
          <TranslationWrapper tKey={"Do you want to activate deliverect?"} />
        </Typography>
        <Typography />
        <Button
          disabled={requestStatus === "loading"}
          onClick={createExternalLocationId}
          startIcon={<Link />}
          variant={"contained"}
        >
          <TranslationWrapper tKey={"Activate Deliverect"} />
        </Button>
      </Stack>
    );
  } else {
    return (
      <Stack alignItems={"center"} direction={"row"} gap={1}>
        <Typography>Deliverect External Location Id:</Typography>
        <Typography sx={{ fontWeight: 800 }}>{externalLocationId}</Typography>
        <Typography>
          <TranslationWrapper tKey={"(provide this to your deliverect onboarding contact)"} />
        </Typography>
      </Stack>
    );
  }
}
